import './comandos.css';

//const Comandos = ({linhas, handleQtdLinhas, elementos, handleSort, qtdRegistros}) => {
const Comandos = ({linhas, handleQtdLinhas, qtdRegistros}) => {
  return (
    <div className='comandos'>
      <div className='qtdregistros'>
        <span>Registros: {qtdRegistros}</span>
      </div>
      <div className='numerolinhas'>
        <span> 
          <label>Linhas por tela: </label>
          <select value={linhas} onChange={({ currentTarget: input}) => {handleQtdLinhas(input.value)}} >
            <option key="1" value='1' >1</option>
            <option key="5" value='5' >5 linhas</option>
            <option key="10" value='10' >10 linhas</option>
            <option key="15" value='15' >15 linhas</option>
            <option key="20" value='20' >20 linhas</option>
            <option key="25" value='25' >25 linhas</option>
            <option key="50" value='50' >50 linhas</option>
            <option key="100" value='100' >100 linhas</option>
          </select>
        </span>
      </div>
    </div>
  )
}

export default Comandos;